import React, { Component, Fragment } from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import PageTransition from 'gatsby-plugin-page-transitions'
import { getPageContents } from '../components/api'
import Slider from 'react-slick'
import Slide from '../components/slide'
import DownloadIcon from '../../assets/icon/download.jpg'
import InstagramIcon from '../../assets/icon/instagram-black.png'
import FacebookIcon from '../../assets/icon/facebook-black.png'

import Responsive from 'react-responsive'

const Mobile = props => <Responsive {...props} maxWidth={767} />
const Desktop = props => <Responsive {...props} minWidth={992} />

const Wrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 100vw;
  background-color: white;
`

const NavigationDimmer = styled.div`
  position: fixed;
  top: 0;
  z-index: 1;
  width: 100vw;
  height: 15vw;
  background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0));
`
const HeroDimmer = styled.div`
  position: absolute;
  left: 0;
  top: 60vh;
  width: 100vw;
  height: 20vh;
  background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.7));
  z-index: 1;
`
const ContentWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100vw;
  background-color: white;
  font-family: OpensansRegular;
`
const ContentBlock = styled.div`
  position: relative;
  padding: 5vw;
  color: gray;
  background-color: white;
  -webkit-columns: 3 200px;
  -moz-columns: 3 200px;
  columns: 3 200px;
  -webkit-column-gap: 4em;
  -moz-column-gap: 4em;
  column-gap: 4em;

  > h2 {
    font-size: 1.7vw;
    font-family: OpensansSemiboldItalic;
    line-height: 1.6;
  }

  > em {
    display: block;
    font-family: OpensansRegular;
    font-style: normal;
    margin-top: 5vw;
    // margin-bottom: 290px;
    text-transform: uppercase;
    font-size: 1.2vw;
  }

  > p {
    column-break-before: always;
    font-family: OpensansRegular;
    font-size: 1vw;
    line-height: 2;
    margin-top: 0.3vw;
  }
  > div {
    column-break-before: always;
  }
  > p > b {
    font-family: OpensansBold;
  }
  > p > a:link,
  > p > a:hover,
  > p > a:visited {
    color: gray;
    font-family: OpensansBold;
    font-style: bold;
    text-decoration: none;
    // font-size: 100px;
  }
`

const ContentBlockMobile = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  padding: 7vw;
  color: gray;

  > p {
    column-break-before: always;
    font-family: OpensansRegular;
    font-size: 2.5vw;
    line-height: 2;
    margin-top: 0.3vw;
  }
  > div {
    column-break-before: always;
  }
  > p > b {
    font-family: OpensansBold;
  }
  > p > a:link,
  > p > a:hover,
  > p > a:visited {
    color: gray;
    font-family: OpensansBold;
    font-style: bold;
    text-decoration: none;
    // font-size: 100px;
  }
`

const Image = styled.div`
  width: 100vw;
  height: 70vh;
  overflow: hidden;
  background-position: no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;

  @media (max-width: 767px) {
    height: 70vw;
  }
`

const Title = styled.div`
  position: absolute;
  top: 70vh;
  left: 7.5vw;
  font-family: OpensansItalic;
  font-size: 2vw;
  color: white;
  z-index: 5;
`

const Social = styled.div`
  opacity: 0.5;
  @media (max-width: 767px) {
    position: fixed;
    left: 10vw;
    bottom: 2vh;
  }
`

const settings = {
  dots: false,
  arrows: false,
  fade: true,
  infinite: true,
  speed: 500,
  autoplay: true,
  lazyLoad: false,
  swipe: false,
  slidesToShow: 1,
  slidesToScroll: 1
}
const content = lang => (
  <Fragment>
    {lang !== '?lang=en' && (
      <Fragment>
        <p>
          <b>Endereço</b>
          <br />
          Rua Alice 29, Laranjeiras <br />
          CEP 22241-020 Rio de Janeiro / RJ
          <br />
        </p>
        <p>
          <b>Entre em contato</b>
          <br />
          E-mail:
          <a href='mailto:escritorio@burlemarx.com.br'>&nbsp;escritorio@burlemarx.com.br</a>
          <br />
          Tel.: 2558-3048 / 2558-3235
          <br />
        </p>
      </Fragment>
    )}
    {lang === '?lang=en' && (
      <Fragment>
        <p>
          <b>Address</b>
          <br />
          Rua Alice 29, Laranjeiras <br />
          CEP 22241-020 Rio de Janeiro / RJ
          <br />
        </p>
        <p>
          <b>Contact us</b>
          <br />
          E-mail:
          <a href='mailto:escritorio@burlemarx.com.br'>&nbsp;escritorio@burlemarx.com.br</a>
          <br />
          Phone: 2558-3048 / 2558-3235
          <br />
        </p>
      </Fragment>
    )}
    <Social>
      <img
        src={InstagramIcon}
        style={{
          width: '41px',
          height: '41px',
          marginTop: `20px`
        }}
        onClick={() => window.open('https://www.instagram.com/escritorioburlemarx/', '_blank')}
      />
      <img
        src={FacebookIcon}
        style={{
          width: '41px',
          height: '41px',
          marginLeft: '20px'
        }}
        onClick={() => window.open('https://www.facebook.com/escritorioburlemarx/', '_blank')}
      />
    </Social>
  </Fragment>
)
class Contact extends Component {
  state = {
    page: { isLoading: true },
    lang: 'pt'
  }
  componentDidMount () {
    this.setState({ isLoading: true })
    const lang = window.location.search
    getPageContents('/contato', lang).then(page => {
      this.setState({ page: page, isLoading: false, lang })
    })
  }

  render () {
    const { slides_1, isLoading, lang } = this.state.page
    return (
      <PageTransition>
        <Wrapper>
          {!isLoading && (
            <Fragment>
              <NavigationDimmer />
              <Image
                style={{
                  backgroundImage: `url(${slides_1[0]})`
                }}
              />
              <ContentWrapper>
                <Mobile>
                  <ContentBlockMobile>{content(this.state.lang)}</ContentBlockMobile>
                </Mobile>
                <Desktop>
                  <ContentBlock>{content(this.state.lang)}</ContentBlock>
                </Desktop>
              </ContentWrapper>
            </Fragment>
          )}
        </Wrapper>
      </PageTransition>
    )
  }
}

export default Contact



// WEBPACK FOOTER //
// ./src/pages/contato.js